const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: []

};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'FORMA_PAGAMENTO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'FORMA_PAGAMENTO_LISTADO':
			return { ...state, lista: action.payload.data };

		case 'FORMA_PAGAMENTO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		default:
			return state;
	}
}
